import { render, staticRenderFns } from "./developerAccountList.vue?vue&type=template&id=8b4508f8&"
import script from "./developerAccountList.vue?vue&type=script&lang=js&"
export * from "./developerAccountList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports